import React from 'react';
import { AuthenticatedUserMenu } from '../authenticated-user-menu';
import SignInButton from '../sign-in-button';

export const Authentication = ({ authentication }) => {
  if (authentication.menu) {
    return <AuthenticatedUserMenu menu={authentication.menu} />;
  }
  return <SignInButton auth={authentication} />;
};
